import { CalibrationConfirmInvoiceDeviceModel } from '../Interface/CalibrationConfirmInvoice_Interface';

type PriceSource = Pick<
  CalibrationConfirmInvoiceDeviceModel,
  'tariff' | 'incRailModir' | 'incPercentModir' | 'incRail' | 'incRailPercent' | 'count'
>;

export function calculateCalibrationUnitPrice(item: PriceSource): number {
  const tariff = toNumber(item.tariff);
  return tariff
    + toNumber(item.incRailModir);
}

export function calculateCalibrationInvoiceTotal(item: PriceSource): number {
  //return calculateCalibrationUnitPrice(item) * toNumber(item.count);
  return calculateCalibrationUnitPrice(item) ;
}



export function calculateCalibrationFinalUnitPrice(item: PriceSource): number {
  const unitPrice = calculateCalibrationUnitPrice(item);
  return unitPrice
    + toNumber(item.incRail)
    + unitPrice * toNumber(item.incRailPercent) / 100;
}

export function calculateCalibrationFinalTotal(item: PriceSource): number {
  //return calculateCalibrationFinalUnitPrice(item) * toNumber(item.count);
  return calculateCalibrationFinalUnitPrice(item) 
}

export function calculateCalibrationFinalTotal2(item: PriceSource): number {
  return calculateCalibrationFinalUnitPrice(item) * toNumber(item.count);
}

function toNumber(value: number | null | undefined): number {
  const numericValue = Number(value);
  return isFinite(numericValue) ? numericValue : 0;
}
